<div class="chat-composer" [class.is-dragging]="dragging" (dragover)="onDragOver($event)" (dragleave)="onDragLeave()" (drop)="onDrop($event)">
  <!-- Staged attachments, removable until the message is sent. A file the server would refuse is
       kept on screen with the reason on its own row, so it is obvious which one to drop. -->
  <div class="chat-composer__files" *ngIf="files.length">
    <div class="chat-composer__file" *ngFor="let staged of files; let i = index" [class.is-invalid]="staged.error">
      <i class="pi" [ngClass]="staged.error ? 'pi-exclamation-circle' : isImage(staged.file) ? 'pi-image' : 'pi-file'"></i>
      <span class="chat-composer__file-name">{{ staged.file.name }}</span>
      <span class="chat-composer__file-size" *ngIf="!staged.error">{{ formatFileSize(staged.file.size) }}</span>
      <span class="chat-composer__file-error" *ngIf="staged.error">{{ staged.error }}</span>
      <button type="button" (click)="removeFile(i)" aria-label="Remove attachment"><i class="pi pi-times"></i></button>
    </div>
  </div>

  <p class="chat-composer__notice chat-composer__notice--warn" *ngIf="attachmentNotice">
    <i class="pi pi-exclamation-triangle"></i>
    {{ attachmentNotice }}
  </p>

  <!-- Recording replaces the input row entirely, so there is no doubt about what is happening -->
  <div class="chat-composer__recording" *ngIf="recording">
    <span class="chat-composer__rec-dot"></span>
    <span class="chat-composer__rec-time">{{ durationLabel(recordingMs) }}</span>
    <span class="chat-composer__rec-label">Recording…</span>
    <button type="button" class="chat-composer__rec-cancel" (click)="cancelRecording()">Cancel</button>
    <button type="button" class="chat-composer__rec-send" (click)="toggleRecording()">
      <i class="pi pi-send"></i>
      Send
    </button>
  </div>

  <div class="chat-composer__row" *ngIf="!recording">
    <button
      type="button"
      class="chat-composer__tool"
      (click)="openFilePicker()"
      [disabled]="disabled"
      title="Attach a file"
      aria-label="Attach a file">
      <i class="pi pi-paperclip"></i>
    </button>

    <textarea
      #input
      rows="1"
      [(ngModel)]="text"
      [attr.maxlength]="maxLength"
      [placeholder]="placeholder"
      [disabled]="disabled"
      (keydown)="onKeydown($event)"
      (input)="onInput()"
      (paste)="onPaste($event)"
      aria-label="Message"></textarea>

    <div class="chat-composer__actions">
      <span class="chat-composer__remaining" *ngIf="showRemaining">{{ remaining }}</span>

      <button type="button" class="chat-composer__tool" (click)="toggleEmoji()" [disabled]="disabled" title="Emoji" aria-label="Insert emoji">
        <i class="pi pi-face-smile"></i>
      </button>

      <button
        type="button"
        class="chat-composer__tool"
        *ngIf="voiceSupported"
        (click)="toggleRecording()"
        [disabled]="disabled"
        title="Record a voice message"
        aria-label="Record a voice message">
        <i class="pi pi-microphone"></i>
      </button>

      <button type="button" class="chat-composer__send" (click)="submit()" [disabled]="!canSend" aria-label="Send message">
        <i class="pi pi-send"></i>
      </button>
    </div>

    <div class="chat-composer__emoji" *ngIf="emojiOpen">
      <button type="button" *ngFor="let emoji of emojis" (click)="insertEmoji(emoji)" [attr.aria-label]="'Insert ' + emoji">{{ emoji }}</button>
    </div>
  </div>

  <!-- Why the box is shut: a deactivated colleague, or the server's rate limit -->
  <p class="chat-composer__notice" *ngIf="notice">
    <i class="pi pi-info-circle"></i>
    {{ notice }}
  </p>

  <p class="chat-composer__hint" *ngIf="!recording && !compact && !notice">
    <strong>Enter</strong> to send · <strong>Shift + Enter</strong> for a new line
  </p>

  <input #fileInput type="file" multiple hidden [attr.accept]="acceptTypes" (change)="onFilesSelected($event)" />
</div>
